export class ServicesResponse {
    resultCount: number;
    limit: number;
    offset: number;
    sortBy: string;
    sortOrder: string;
    results?: (ServiceBasicInfo)[] | null;
    myItemsCount: number;
    myServiceCount: number;
    serviceCatalogCount: number;
}

export class ServiceBasicInfo {
    itemId: number;
    itemName: string;
    itemTypeName: string;
    itemIdentifier: string;
    itemStatus: string;
    serviceLevel: boolean;
}
